<template>
  <lk-select
    v-model="selectedId"
    clearable
    @on-change='handleChange'
    class="item"
    filterable
    :multiple="multiple"
    :transfer="true"
    :loading="false">
    <lk-option
      v-for="item in supplierList"
      :key="item.id"
      :value="item.id">{{item.label}}</lk-option>
  </lk-select>
</template>
<script>
import utils from '../libs/utils';
import supplier from '../services/supplier';


export default {
  name: 'SupplierListSelect',
  props: {
    value: {
      type: [Number, Array, String],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    status: Number,
    purchaseType: Number,
    isGeneral: { // true的时候 支持基础供应商使用该组件
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'value',
    event: 'on-change',
  },
  data() {
    return {
      supplierList: [],
      selectedId: '',
    };
  },
  computed: {
    // 如果传递了status、isGeneral条件，则列表不能公用，下次进入要重新请求数据
    withoutConditions() {
      return utils.isEmpty(this.status) && !this.isGeneral;
    },
  },
  watch: {
    value(val = '') {
      this.selectedId = val;
    },
  },
  methods: {
    clear() {
      this.selectedId = '';
      this.$emit('on-change', '');
    },
    handleChange(val) {
      let selectedItem = {};
      this.supplierList.forEach((supplierItem) => {
        if (supplierItem.id === val) {
          selectedItem = supplierItem;
        }
      });
      this.$emit('on-change', val, selectedItem);
    },
    getSuppliers() {
      if (this.$store.state.user.supplierList.length && this.withoutConditions) {
        this.supplierList = this.$store.state.user.supplierList;
      } else {
        this.$store.commit('setDisableLoading', true);
        const params = {};
        if (!utils.isEmpty(this.status)) {
          params.status = this.status;
        }

        // SupplierGeneralList 基础供应商, SupplierStoreOuterList 首营供应商
        const finnalAction = this.isGeneral ? supplier.SupplierGeneralList : supplier.SupplierStoreOuterList;
        params.purchaseType = this.purchaseType;
        finnalAction(params).then((res) => {
          if (res.data.status === 200) {
            const data = this.isGeneral ? res.data.data.list : res.data.data;
            data.forEach((item) => {
              if (!this.isGeneral) {
                // 首营供应商返回的数据结构多了一层 outerPassInfo ，少了一层list
                item = Object.assign(item, item.outerPassInfo);
              }
              item.label = item.name;
            });
            this.supplierList = data;
            this.withoutConditions && this.$store.commit('setSupplierList', this.supplierList);
            if (this.selectedId) {
              this.supplierList.find(item => item.id === this.selectedId) || this.clear();
            }
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          console.log(err);

          utils.handleError(err);
        });
      }
    },
  },
  mounted() {
    this.selectedId = this.value;
    this.getSuppliers();
  },
};
</script>
